<template>
  <div>
    <ClinicPageHeader
      title="Acompanhamento"
      subtitle="Pacientes sem retorno, oportunidades e campanhas de reativação"
    />

    <div class="dbody">
      <!-- Sub-navegação de acompanhamento -->
      <div class="tabs" style="margin-bottom:var(--space-6)">
        <router-link
          class="tab"
          active-class="tab--active"
          exact
          :to="{ name: 'ClinicNoReturn' }"
        >
          Sem retorno
        </router-link>
        <router-link
          class="tab"
          active-class="tab--active"
          exact
          :to="{ name: 'ClinicOpportunities' }"
        >
          Oportunidades
        </router-link>
        <router-link
          class="tab"
          active-class="tab--active"
          exact
          :to="{ name: 'ClinicCampaigns' }"
        >
          Campanhas
        </router-link>
      </div>

      <!-- Erro -->
      <ClinicStateBox
        v-if="state === 'error'"
        state="error"
        title="Não foi possível carregar as oportunidades"
        message="Ocorreu um erro ao buscar as oportunidades de retorno. Tente novamente."
      >
        <template #actions>
          <button class="btn btn--primary btn--sm" @click="reload">
            Tentar de novo
          </button>
        </template>
      </ClinicStateBox>

      <!-- Loading -->
      <template v-else-if="state === 'loading'">
        <div class="opp-grid" style="margin-bottom:var(--space-6)">
          <div v-for="i in 3" :key="i" class="card opp-card">
            <div
              class="skel-line"
              style="width:90px;height:22px;margin-bottom:4px"
            />
            <div class="skel-line" style="width:40px;height:32px" />
            <div class="skel-line" style="width:100%;height:32px" />
            <div class="skel-line" style="width:100%;height:34px" />
          </div>
        </div>
        <div class="card">
          <div class="skel-line" style="width:40%;margin-bottom:20px" />
          <div class="skel-line" style="width:100%;height:120px" />
        </div>
      </template>

      <!-- Conteúdo -->
      <template v-else>
        <div class="opp-grid" style="margin-bottom:var(--space-6)">
          <div v-for="c in categories" :key="c.label" class="card opp-card">
            <span
              class="badge badge--no-dot tag"
              :class="`badge--${c.variant}`"
            >
              {{ c.label }}
            </span>
            <span class="opp-n">{{ c.count }}</span>
            <p
              style="font-size:var(--font-size-sm);color:var(--color-gray-500)"
            >
              {{ c.desc }}
            </p>
            <button
              class="btn btn--outline btn--sm btn--block"
              @click="goGroup(c)"
            >
              Ver pacientes
            </button>
          </div>
        </div>

        <div class="card card--flush">
          <div class="card-head flush">
            <h3>Oportunidades priorizadas</h3>
            <span class="badge badge--neutral badge--no-dot">
              {{ opportunities.length }} elegíveis
            </span>
          </div>

          <table
            v-if="opportunities.length"
            class="table"
            style="margin-top:var(--space-2)"
          >
            <thead>
              <tr>
                <th>Paciente</th>
                <th>Tipo</th>
                <th>Motivo</th>
                <th>Potencial</th>
                <th class="t-right">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="o in opportunities"
                :key="o.name"
                class="tr--link"
                @click="goPatient(o)"
              >
                <td>
                  <div class="row" style="gap:var(--space-3)">
                    <div class="avatar avatar--sm" :class="o.av">
                      {{ o.initials }}
                    </div>
                    <span class="cell-strong">{{ o.name }}</span>
                  </div>
                </td>
                <td>
                  <span
                    class="badge badge--no-dot"
                    :class="`badge--${o.typeVariant}`"
                  >
                    {{ o.type }}
                  </span>
                </td>
                <td style="color:var(--color-gray-500)">{{ o.reason }}</td>
                <td class="num money">{{ formatMoney(o.potential) }}</td>
                <td class="t-right">
                  <button
                    class="btn btn--primary btn--sm"
                    @click.stop="acionar"
                  >
                    Acionar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <ClinicStateBox
            v-else
            state="empty"
            title="Nenhuma oportunidade no momento"
            message="Não há oportunidades priorizadas para exibir."
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ClinicFollowup } from "@/services/clinica";
import { formatMoney } from "@/data/clinica";
import ClinicPageHeader from "@/components/clinica/ClinicPageHeader.vue";
import ClinicStateBox from "@/components/clinica/ClinicStateBox.vue";

export default {
  name: "ClinicOpportunities",
  components: { ClinicPageHeader, ClinicStateBox },
  data() {
    return {
      // Estado de carga (loading/ready/error). Preview de erro via ?state=error.
      state: "loading",
      categories: [],
      // Lista priorizada real (grupo Retorno) — vinda de /clinica/opportunities.
      opportunities: []
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    formatMoney,
    async fetch() {
      this.state = "loading";
      try {
        const fail = this.$route.query.state === "error";
        const { data } = await ClinicFollowup.opportunities({ fail });
        this.categories = data.groups.map(g => ({
          label: g.label,
          variant: g.tagVariant,
          count: g.count,
          desc: g.description
        }));
        this.opportunities = data.items || [];
        this.state = "ready";
      } catch (e) {
        this.state = "error";
      }
    },
    reload() {
      this.fetch();
    },
    goPatient(o) {
      this.$router.push({
        name: "ClinicPatientProfile",
        params: { id: o.patientId }
      });
    },
    acionar() {
      this.$router.push({ name: "ClinicCampaigns" });
    },
    // Único grupo com fonte hoje é "Retorno" → lista de sem-retorno.
    goGroup() {
      this.$router.push({ name: "ClinicNoReturn" });
    }
  }
};
</script>
